import AuthManager from "../../common/auth/Manager";

export default (to, from, next) => {
  if (!AuthManager.isMensurationForbidden()) {
    next();
  } else {
    next(from && from.name ? false : {'name': 'default'});
  }
};



// WEBPACK FOOTER //
// ./src/router/hooks/isMensurationForbidden.js